// ***************************************************************************************
// onHandleChangeScroll()
// permet de récupérer la valeur du scroll
// ***************************************************************************************
export function onHandleChangeScroll(event) {
  if (!this.script || !this.script.length) {
    return;
  }

  event.preventDefault();

  if (this.state.speakerMenu.display) {
    this.onCloseSpeakerMenu();
    return;
  }

  if (this.state.contextMenu.display) {
    this.onCloseContextMenu();
    return;
  }

  const scrollValue = Number.parseInt(event.target.value);

  if (!this.lockScroll) {
    const nextPositionWord = this.script.findIndex(
      (x) => x.indexLine === scrollValue
    );
    if (nextPositionWord === -1) {
      throw Error('nextPositionWord undefined');
    }
    this.currentWordIndex = nextPositionWord;
    this.currentLineIndex = scrollValue;
    this.currentLetterIndex = 0;
  }

  this.scrolling = true;

  this.scrollTo(scrollValue, true);
}

// ***************************************************************************************
// onWheel()
// permet de scroller avec la souris
// ***************************************************************************************
export function onWheel(event) {

  if (this.state.speakerMenu.display) {
    return;
  }

  if (this.state.contextMenu.display) {
    this.onCloseContextMenu();
    return;
  }

  // metaKey pour MAC
  if (event.ctrlKey || event.metaKey) {
    event.preventDefault();

    this.onZoom(event.deltaY < 0 ? 'ZOOMIN' : 'ZOOMOUT');

    return;
  }

  if (!this.script || !this.script.length) {
    return;
  }


  event.preventDefault();
  this.scrolling = true;

  let moveCursor = false;

  if (event.deltaY > 0) {
    // Défilement vers le bas
    if (this.scrollOffsetLine >= this.state.maxScrollValue) {
      return;
    }

    this.scrollOffsetLine++;

    if (!this.lockScroll) {

      let startY = this.metricY;
      if (this.props.speakers && this.props.speakers.length) {
        startY = 30;
      }

      moveCursor = this.currentWord.y === startY;
    }
  } else {
    // Défilement vers le haut
    if (this.scrollOffsetLine === 0) {
      return;
    }

    this.scrollOffsetLine--;
    if (!this.lockScroll) {
      moveCursor =
        this.currentWord.y === this.metricY ||
        this.height < this.currentWord.y + this.lineHeight;
    }
  }

  if (moveCursor) {
    const nextPositionWord = this.script.find(
      (x) => x.indexLine === this.scrollOffsetLine
    );

    if (!nextPositionWord) {
      return;
    }

    this.currentWordIndex = nextPositionWord.index;
    this.currentLineIndex = nextPositionWord.indexLine;
    this.currentLetterIndex = 0;
  }

  this.scrollTo(this.scrollOffsetLine, true);
}

// ***************************************************************************************
// onScrollKeyDown()
// permet de scroller avec le clavier quand le scroll (input range) a le focus
// ***************************************************************************************
export function onScrollKeyDown(event) {
  event.preventDefault();
  event.stopPropagation();

  const { code, shiftKey } = event;

  if (code === 'Tab' && shiftKey) {
    const element = document.querySelector('#textDiv');
    if (element) {
      element.focus();
    }

    return;
  }

  if (code === 'ArrowLeft' || code === 'ArrowRight') {
    const element = document.querySelector('#textDiv');
    if (element) {
      element.focus();
    }

    this.onMoveCursorLetterByLetter(code === 'ArrowLeft' ? 'LEFT' : 'RIGHT');
    return;
  }

  if (code !== 'ArrowDown' && code !== 'ArrowUp') {
    return;
  }

  if (code === 'ArrowDown') {
    if (this.scrollOffsetLine === this.state.maxScrollValue) {
      return;
    }

    this.scrollOffsetLine++;
  } else {
    if (this.scrollOffsetLine === 0) {
      return;
    }

    this.scrollOffsetLine--;
  }

  this.scrolling = true;
  this.changeScrollValueState(this.scrollOffsetLine);

  this.onRefreshCanvas();

  if (!this.lockScroll) {
    const nextPositionWord = this.script.findIndex(
      (x) => x.indexLine === this.scrollOffsetLine
    );

    this.currentWordIndex = nextPositionWord;
    this.currentLineIndex = this.scrollOffsetLine;
    this.currentLetterIndex = 0;

    this.onMove();
  }
}

export function onZoom(key) {
  let { baseFontSize, fontSize } = this.state.font;

  let px = parseFloat((fontSize / baseFontSize).toFixed(2));

  if (key === 'NOZOOM') {
    this.setState({
      font: {
        ...this.state.font,
        fontSize: this.state.font.baseFontSize,
        px: 1,
      },
    });
    return;
  }
  if (key === 'ZOOMIN') {
    if (px === 4) {
      return;
    }

    fontSize++;
  } else {
    if (px <= 0.6) {
      return;
    }

    fontSize--;
  }

  px = fontSize / baseFontSize;

  this.setState({ font: { ...this.state.font, fontSize, px } });
}
